import { Component } from 'vue-property-decorator'

import AccountsList from '@/modules/Account/scripts/accounts-list'

@Component({})
export default class AccountsListFromDashboard extends AccountsList {
  async mounted () {
    this.onResize()
    await this.clearPage()
    this.getList()
  }
}
